// File: assets/pantribot-publish.js
(function () {
  const API = (window.PANTRIBOT_API || "https://api.pantribot.com").replace(/\/+$/, "");

  const CUSTOMER = window.PANTRIBOT_CUSTOMER || {};
  const CUSTOMER_ID = CUSTOMER?.id || null;
  const LOGGED_IN = !!CUSTOMER?.loggedIn;

  function apiUrl(path) {
    return `${API}${path}`;
  }

  async function apiFetch(path, opts = {}) {
    return fetch(apiUrl(path), { mode: "cors", ...opts });
  }

  async function authExchangeFresh() {
    if (!LOGGED_IN || !CUSTOMER_ID) throw new Error("Please log in to publish.");

    const qs = `?user_id=${encodeURIComponent(String(CUSTOMER_ID))}`;

    const res = await apiFetch(`/v1/auth/exchange${qs}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
    });

    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(`auth/exchange failed: HTTP ${res.status} ${text}`.trim());
    }

    const data = await res.json().catch(() => null);
    if (!data?.token) throw new Error("auth/exchange missing token");

    return data.token;
  }

  async function publishDraft({ endpoint, method, draftId, token }) {
    const cleanMethod = (method || "POST").toUpperCase();
    const qs = `?id=${encodeURIComponent(String(draftId))}`;
    const path = `${endpoint}${qs}`;

    const res = await apiFetch(path, {
      method: cleanMethod,
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    });

    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(`publish failed: HTTP ${res.status} ${text}`.trim());
    }

    const ct = res.headers.get("content-type") || "";
    if (!ct.includes("application/json")) return { ok: true };
    return res.json();
  }

  function wire() {
    const roots = document.querySelectorAll("[data-ptb-publish]");
    roots.forEach((root) => {
      if (root.__ptbWired) return;
      root.__ptbWired = true;

      const btn = root.querySelector(".ptbpub2-btn");
      const msgEl = root.querySelector(".ptbpub2-msg");
      const progEl = root.querySelector(".ptbpub2-progress");
      const fillEl = root.querySelector(".ptbpub2-fill");
      const pctEl = root.querySelector(".ptbpub2-pct");

      if (!btn) return;

      const setMsg = (t) => { if (msgEl) msgEl.textContent = t || ""; };
      const setProgress = (pct) => {
        const p = Math.max(0, Math.min(100, Math.round(pct)));
        if (fillEl) fillEl.style.width = `${p}%`;
        if (pctEl) pctEl.textContent = `${p}%`;
      };
      const showProgress = () => { if (progEl) progEl.style.display = "flex"; };

      btn.addEventListener("click", async () => {
        const draftId = btn.getAttribute("data-draft-id");
        const endpoint = btn.getAttribute("data-endpoint") || "/v1/draft/publish";
        const method = btn.getAttribute("data-method") || "POST";

        if (!draftId) {
          setMsg("Missing draft id.");
          return;
        }

        btn.disabled = true;
        setMsg("Publishing…");
        setProgress(0);
        showProgress();

        // Fake progress so it feels alive
        let running = true;
        let pct = 0;
        const tick = () => {
          if (!running) return;
          pct = pct < 60 ? pct + 8 : pct < 85 ? pct + 3 : pct < 92 ? pct + 1 : pct;
          setProgress(pct);
          setTimeout(tick, 140);
        };
        tick();

        try {
          const token = await authExchangeFresh();
          await publishDraft({ endpoint, method, draftId, token });

          running = false;
          setProgress(100);
          setMsg("Published ✅");

          // 🔥 IMPORTANT PART 🔥
          // Hard refresh so product tags/status update in Shopify editor
          setTimeout(() => {
            window.location.reload();
          }, 600);

        } catch (e) {
          running = false;
          console.error("[PTB publish] error", e);
          setProgress(0);
          setMsg(e?.message || "Publish failed. Check console.");
          btn.disabled = false;
        }
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", wire);
  } else {
    wire();
  }
})();
